import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createOneViewReportApi(params: any) {
  let apiData: any = {
    startDate: params.startDate,
    endDate: params.endDate,
    productExternalId: params.productTypeId.externalId,
    programExternalId: params.programmeId.length ? params.programmeId : null,
    customerExternalId: params.customerId.length ? params.customerId : null,
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/one-view-report`;
  return api.create(`${backendApiUrl}`, apiData);
}

export { createOneViewReportApi };